import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationConstant } from 'src/app/shared/constant/navigation.constant';
import { OvoStorage } from '../../../../../shared/storage/ovo.storage';
import { RequestHelper } from 'src/app/shared/helper/request.helper';
import { environment } from 'src/environments/environment';
import { APIConstant } from 'src/app/shared/constant/api.constant';

@Component({
  selector: 'app-payment-ovo',
  templateUrl: './payment-ovo.component.html',
  styleUrls: ['./payment-ovo.component.css']
})

export class PaymentOvoComponent implements OnInit {
  isLoading: boolean;
  isSuccess: boolean;
  invoiceNumber: string;
  transactionDate: string;
  ovoBalance: string;
  ovoCash: string;
  merchantName: string;
  transactionAmount: string;
  phoneNumber: string;
  transactionId: string;
  ovoName: string;
  paymentType = '1';

  constructor(
    private router: Router,
    private ovoStorage: OvoStorage,
    private apiService: RequestHelper
  ) {
    this.isSuccess = true;
    this.isLoading = false;
  }

  ngOnInit(): void {
    if(this.ovoStorage.data == null){
      this.router.navigate([NavigationConstant.OVO_INQUIRY]);
    }

    this.invoiceNumber = this.ovoStorage.data.invoiceNumber;
    this.transactionDate = this.ovoStorage.data.transactionDate;
    this.ovoBalance = this.ovoStorage.data.ovoBalance;
    this.ovoCash = this.ovoStorage.data.ovoCash;
    this.merchantName = this.ovoStorage.data.merchantName;
    this.transactionAmount = this.ovoStorage.data.transactionAmount;
    this.phoneNumber = this.ovoStorage.data.phoneNumber;
    this.transactionId = this.ovoStorage.data.transactionId;
    this.ovoName = this.ovoStorage.data.name;
  }

  selectPayment(selectedPayment) {
    this.paymentType = selectedPayment;
  }

  submitPayment() {
    let payload = {
      'transactionId' : this.transactionId,
      'paymentType' :this.paymentType,
      'merchantInvoice' : this.invoiceNumber,
      'phoneNumber' : this.phoneNumber
    }
    this.isLoading = true;
    this.apiService.post(environment.walletApiUrl + APIConstant.OVO_PAYMENT, JSON.stringify(payload)).subscribe((data) => {
      if(data.responseCode == '00'){
        this.ovoStorage.data.response = data;
        this.router.navigate([NavigationConstant.OVO_PAYMENT_RESULT])
      }
    }, (err) => this.isLoading = false);
    this.isLoading = false;
  }

}
